import Select from './Select.vue'

export { Select }
export default Select
